import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant8PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 987 759",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.1807 367.437C123.574 386.513 179.868 405.86 237.25 405.362C287.697 404.954 340.682 385.516 369.011 343.785C405.18 290.409 392.444 217.324 418.098 158.194C445.338 95.3483 521.304 56.3814 587.116 75.5477C652.929 94.714 696.441 172.829 673.778 237.487C654.47 292.584 598.176 326.929 573.201 379.716C538.845 452.213 574.516 542.833 636.113 594.26C713.891 659.145 819.816 675.366 916.949 688.823",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant8PathwayIllustration as default };
